module.exports = __webpack_public_path__ + "static/media/global-logo.bbf27e9e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/clients/global-logo.jpg
 ** module id = 771
 ** module chunks = 0
 **/